import * as React from "react";
import { validators } from "not-valid";

import { BaseInput, SharedProps } from "../base-input";

export interface NumberInputProps extends SharedProps<number> {
}

export class NumberInput extends React.Component<NumberInputProps, {}> {

    public render() {
        const NumericBaseInput = BaseInput as unknown as new () => BaseInput<number>;

        const defaultValue = this.props.required
            ? 0
            : null;

        return (
            <NumericBaseInput
                defaultValue={defaultValue}
                getValueFromInput={this.getValueFromInput}
                type="number"
                requiredValidator={validators.requiredNumber()}
                {...this.props}
            />
        );
    }

    private getValueFromInput(value: string): number {
        const parsed = +value;
        return isNaN(parsed) || value === "" ? null : parsed;
    }
}
